import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';

import { LayoutModule } from './views/layout/layout.module';
import { AuthGuard } from './core/guard/auth.guard';

import { AppComponent } from './app.component';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';

import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { headerInterceptor } from './services/interceptorLang.service';
import { ToastrModule } from 'ngx-toastr';
// import { TranslateModule,TranslateLoader } from '@ngx-translate/core';
// import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { CommonModule } from '@angular/common';
import { NotificationsComponent } from './views/pages/notifications/notifications.component';
import { QuillModule } from 'ngx-quill';
import { EncryptionInterceptor } from './services/encryptInterceptor.service';
import { TokenService } from './services/token.service';
import { MatDialogModule } from '@angular/material/dialog';
// import { EncryptionInterceptor } from './services/encryptInterceptor.service';
// import { EditRoleComponent } from './views/page/roles/edit-role/edit-role.component';

@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,
    NotificationsComponent,
    NotificationsComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    QuillModule,
    MatDialogModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(), 
    // LayoutModule,
    TranslateModule.forRoot({
      defaultLanguage:'en',
      loader:{
        provide:TranslateLoader,
        useFactory:CreateTranslateLoader,
        deps:[HttpClient]
      }
    })
  ],
  providers: [
    AuthGuard,
    TokenService,
    {
      provide: HIGHLIGHT_OPTIONS, // https://www.npmjs.com/package/ngx-highlightjs
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        languages: {
          xml: () => import('highlight.js/lib/languages/xml'),
          typescript: () => import('highlight.js/lib/languages/typescript'),
          scss: () => import('highlight.js/lib/languages/scss'),
        }
      }
    },
    {
      provide:HTTP_INTERCEPTORS,
      useClass:headerInterceptor,
      multi:true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncryptionInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function CreateTranslateLoader(http:HttpClient){
  return new TranslateHttpLoader(http,'./assets/i18n/','.json')
}